import React from 'react'
import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "CustomerPortalModule"
const debug = false

export class CustomerPortalModule extends ModuleProto {

    public isNotificationsEnabled   : boolean

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.CUSTOMER_PORTAL, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Customer Portal"
        this.description                = "The Customer Portal module facilitates effective collaboration between your team and external stakeholders. It empowers clients to engage directly with project details, track progress, provide feedback, and access relevant documentation in a secure and user-friendly environment. By offering transparency and real-time updates, the Customer Portal enhances project communication and fosters stronger client relationships, ultimately driving project success. \n \n Customer accounts are not counted towards your organization's license (provided free of charge) but have limited functionality. \n\n This module requires the GoodDay CRM module to be enabled first."
        this.svgIcon                    = "isvg-customer-portal"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "CRM"
        this.settingsUrl                = "settings/customer-portal"
        this.parentSection              = SettingsParentSection.CRM

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.isNotificationsEnabled     = _.get(moduleConfig,'isNotificationsEnabled', false) as boolean


        this.feature                    = Feature.CRM
        this.validateFeature()

    }

    get enabled() {
        return super.enabled && gd.modules.crm.enabled
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();

        if (this.isNotificationsEnabled) {
            result['isNotificationsEnabled'] = true
        }

        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}
